import React from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { KeepScale } from 'react-zoom-pan-pinch';
import { HouseIcon } from './lib';

export default function Hotspot({
  adjustX,
  adjustY,
  multiplier,
  plot,
  resetFilters,
}) {
  return (
    <Tabs.List>
      <Tabs.Trigger
        asChild
        onClick={() => {
          resetFilters();
        }}
        value={plot.label}
      >
        <button
          className="siteplan__marker"
          key={plot.id}
          style={{
            left: `${multiplier ? plot.x * multiplier : plot.x * adjustX}px`,
            top: `${multiplier ? plot.y * multiplier : plot.y * adjustY}px`,
          }}
          type="button"
        >
          <KeepScale>
            <span
              className={`siteplan__plot siteplan__plot--${plot.type} siteplan__plot--${plot.status}`}
            >
              {plot.type === 'apartment' && <HouseIcon />}

              <span className={`siteplan__label siteplan__label--${plot.type}`}>
                {plot.label}
              </span>
            </span>
          </KeepScale>
        </button>
      </Tabs.Trigger>
    </Tabs.List>
  );
}
